import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LANGS = [
  { code: 'pt', label: 'PT', name: 'Português' },
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'es', label: 'ES', name: 'Español' },
];

const LanguageSwitcher = ({ compact = false }) => {
  const { i18n } = useTranslation();
  const current = i18n.language?.split('-')[0] || 'pt';

  if (compact) {
    return (
      <select
        data-testid="lang-switcher"
        value={current}
        onChange={(e) => i18n.changeLanguage(e.target.value)}
        className="px-3 py-1.5 bg-white border border-border rounded-full text-sm font-semibold cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary"
      >
        {LANGS.map((l) => (
          <option key={l.code} value={l.code}>
            {l.label}
          </option>
        ))}
      </select>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <Globe className="w-4 h-4 text-muted-foreground" />
      <div className="flex gap-1">
        {LANGS.map((l) => (
          <button
            key={l.code}
            data-testid={`lang-${l.code}`}
            onClick={() => i18n.changeLanguage(l.code)}
            className={`px-2 py-1 rounded-full text-xs font-bold transition-colors ${
              current === l.code
                ? 'bg-primary text-primary-foreground'
                : 'bg-white border border-border text-muted-foreground hover:border-primary'
            }`}
          >
            {l.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
